import script from "./NavTree.vue?vue&type=script&setup=true&lang=js"
export * from "./NavTree.vue?vue&type=script&setup=true&lang=js"

import "./NavTree.vue?vue&type=style&index=0&id=71a6edae&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71a6edae"]])

export default __exports__